<div class="db-create">
  <div class="db-create-wrap" *ngIf="pageId === 'create'" dbCustomScrollbar>
    <div class="db-create-wrap-title">{{'text_createWebsiteStepTitle' | dbText}}</div>
    <div class="db-create-wrap-desc">{{'text_createWebsiteStepDesc' | dbText}}</div>
    <div class="db-create-wrap-blocks">
      <div class="db-create-wrap-block-item" *ngFor="let block of blocks" (click)="goToNextStep(block.url)">
        <div class="db-create-wrap-block-img">
          <img *ngIf="block.img" [alt]="block.title | dbText" [src]="block.img"/>
        </div>
        <div class="db-create-wrap-block-title" [innerHtml]="block.title | dbText"></div>
        <div class="db-create-wrap-block-desc" [innerHtml]="block.desc | dbText"></div>
        <div class="db-create-wrap-block-icon"><span><i class="db-icon db-icon-ds-arrow-small"></i></span></div>
      </div>
    </div>
  </div>
  <div class="db-create-router-wrap"  *ngIf="pageId !== 'create'"><router-outlet></router-outlet></div>

</div>
